import { redirect } from 'react-router-dom'
import { getIdToken } from '../providers/FirebaseProvider'
import { getAuthProvider } from './authProviderStorage'
import { getAuthToken } from './authTokenStorage'

const getSessionToken = async (): Promise<string | null> => {
  const provider = getAuthProvider()
  if (!provider) return null

  if (provider === 'firebase' || provider === 'google') {
    return await getIdToken()
  }

  return getAuthToken(provider)
}

const isAuthenticated = async (): Promise<boolean> => {
  return Boolean(await getSessionToken())
}

export const requireAuthentication = async () => {
  /** @todo #124 firebaseにはアカウントがあるが、shiboruuにはアカウントがない場合の処理を追加する */
  if (await isAuthenticated()) return null
  return redirect('/')
}

export const rootLoader = async () => {
  if (await isAuthenticated()) return redirect('/home')
  return redirect('/login')
}
